var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.681 473.681",
    style: {
      enableBackground: "new 0 0 473.681 473.681"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.851,
    r: 236.83
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E12A28"
    },
    d: "M460.143,157.874c-0.026-0.075-0.049-0.138-0.075-0.206C429.756,72.202,351.789,9.321,258.113,0.974 c36.248,19.872,46.834,82.832,56.109,156.901c6.335,50.593,6.376,106.339,0.12,156.995c-9.196,74.47-19.827,137.874-56.228,157.829 c93.848-8.362,171.927-71.46,202.12-157.156c0.079-0.228,0.146-0.452,0.228-0.673c8.526-24.438,13.219-50.682,13.219-78.026 C473.677,209.141,468.879,182.575,460.143,157.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED3432"
    },
    d: "M326.412,157.874c-9.27-74.07-32.052-137.029-68.303-156.901C251.097,0.352,244.007,0,236.835,0 C133.806,0,46.188,65.803,13.608,157.668c-0.026,0.067-0.049,0.131-0.075,0.206C4.798,182.575,0,209.141,0,236.842 c0,27.348,4.693,53.588,13.219,78.026c0.079,0.221,0.15,0.445,0.228,0.673c32.452,92.102,120.19,158.135,223.387,158.135 c7.173,0,14.263-0.352,21.274-0.98c36.401-19.954,59.227-83.359,68.423-157.829C332.788,264.209,332.747,208.467,326.412,157.874z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDCE0C"
    },
    points: "234.718,115.454 262.851,202.047 353.906,202.047 280.24,255.555 308.376,342.157  234.718,288.636 161.056,342.157 189.193,255.555 115.53,202.047 206.582,202.047 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.a8abdb94185c21a3f6ad2a45bc18f6be.svg";
export { ForwardRef as ReactComponent };